/**
 * Using common js to reuse this file in both webpack and editor
 */

module.exports = {
  Desktop: require('./handlebars-helpers/Desktop'),
  Mobile: require('./handlebars-helpers/Mobile'),
  eq: require('./handlebars-helpers/eq'),
  font_quote: require('./handlebars-helpers/font_quote'),
  list: require('./handlebars-helpers/list'),
  ln2br: require('./handlebars-helpers/ln2br'),
  low: require('./handlebars-helpers/low'),
  math: require('./handlebars-helpers/math'),
  neq: require('./handlebars-helpers/neq'),
  route: require('./handlebars-helpers/route'),
  t: require('./handlebars-helpers/t'),
  upp: require('./handlebars-helpers/upp')
};
